/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import DomainModel from 'cio/models/domain';
import IdentityModel from 'cio/models/identity';
import { Task } from 'ember-concurrency';
import { scheduleOnce } from '@ember/runloop';

interface SendingDomainsDomainArgs {
  domain: DomainModel;
  deleteDomainTask: Task<DomainModel, [DomainModel]>;
  isEditing: boolean;
  toggleEditing: (name: string) => unknown;
  readOnly: boolean;
  identities: IdentityModel[];
  identitiesInUse: IdentityModel[];
  onUpdateIdentity: () => unknown;
  hasDynamicIdentities: boolean;
  hasCustomMailServers: boolean;
}

export default class SendingDomainsDomain extends Component<SendingDomainsDomainArgs> {
  @tracked isConfirmingDelete = false;
  @tracked element!: HTMLElement;
  @tracked isAddingFromAddress = false;

  get isDomainInUse() {
    return this.args.identities?.any((identity) => this.args.identitiesInUse.includes(identity));
  }

  scrollIntoView() {
    this.element.scrollIntoView({ behavior: 'smooth' });
  }

  @action
  scrollIfEditing(element: HTMLElement) {
    if (!this.args.isEditing) {
      return;
    }

    this.element = element;
    scheduleOnce('afterRender', this, this.scrollIntoView);
  }
  @action
  toggleConfirmingDelete() {
    this.isConfirmingDelete = !this.isConfirmingDelete;
  }
  @action
  deleteDomain(event: Event) {
    event.preventDefault();
    return this.args.deleteDomainTask.perform(this.args.domain);
  }

  @action
  toggleAddingFromAddress() {
    this.isAddingFromAddress = !this.isAddingFromAddress;
  }

  @action
  async onSaveIdentity() {
    await this.args.onUpdateIdentity();
    this.isAddingFromAddress = false;
  }
}
